<!--
  - @copyright Copyright (c) 2018 René Gieling <github@dartcafe.de>
  -
  - @author René Gieling <github@dartcafe.de>
  -
  - @license GNU AGPL version 3 or any later version
  -
  - This program is free software: you can redistribute it and/or modify
  - it under the terms of the GNU Affero General Public License as
  - published by the Free Software Foundation, either version 3 of the
  - License, or (at your option) any later version.
  -
  - This program is distributed in the hope that it will be useful,
  - but WITHOUT ANY WARRANTY; without even the implied warranty of
  - MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  - GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -
  -->

<template>
	<transition-group name="fade" class="comments" tag="ul">
		<CommentItem v-for="(comment) in sortedList"
			:key="comment.id"
			:comment="comment"
			tag="li" />
	</transition-group>
</template>

<script>
import sortBy from 'lodash/sortBy'
import CommentItem from './CommentItem.vue'
import { mapState } from 'vuex'

export default {
	name: 'Comments',
	components: {
		CommentItem,
	},
	data() {
		return {
			sort: 'timestamp',
			reverse: true,
		}
	},

	computed: {
		...mapState({
			comments: (state) => state.comments.list,
		}),

		sortedList() {
			if (this.reverse) {
				return sortBy(this.comments, this.sort).reverse()
			}
			return sortBy(this.comments, this.sort)

		},

	},
}
</script>
